import { render, staticRenderFns } from "./CampaignManager.vue?vue&type=template&id=388424fc&scoped=true&"
import script from "./CampaignManager.vue?vue&type=script&lang=js&"
export * from "./CampaignManager.vue?vue&type=script&lang=js&"
import style0 from "./CampaignManager.vue?vue&type=style&index=0&id=388424fc&prod&lang=scss&"
import style1 from "./CampaignManager.vue?vue&type=style&index=1&id=388424fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388424fc",
  null
  
)

export default component.exports